import React, { useState } from "react";
import { Radio, Space, Form, Input } from "antd";

const FilterRadio = ({ filter, showLabel = false }) => {
  const [radioFilter, setRadioFilter] = useState("");

  const onInputChange = ({ target: { value } }) => {
    setRadioFilter(value);
  };

  return (
    <>
      {Object.values(filter.values)?.length > 10 && (
        <Input
          onChange={onInputChange}
          placeholder={`Busque por ${filter.label}`}
          value={radioFilter}
          style={{ marginBottom: "20px" }}
        />
      )}

      <Form.Item name={filter.facet} label={showLabel && filter.label}>
        <Radio.Group
          style={{
            maxHeight: "300px",
            overflowY: "auto",
            width: "100%",
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          <Space direction="vertical" style={{ rowGap: "0px" }}>
            {Object.values(filter.values)?.map(
              (option) =>
                option[1].toLowerCase().includes(radioFilter.toLowerCase()) && (
                  <Radio
                    key={`${option[0]}-radio`}
                    value={option[0]}
                    style={{ marginBottom: "8px" }}
                  >
                    {option[1]}
                  </Radio>
                )
            )}
          </Space>
        </Radio.Group>
      </Form.Item>
    </>
  );
};

export default FilterRadio;
